import { render, staticRenderFns } from "./vue-form-renderer.vue?vue&type=template&id=4a52853d&scoped=true&"
import script from "./vue-form-renderer.vue?vue&type=script&lang=js&"
export * from "./vue-form-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52853d",
  null
  
)

export default component.exports